export const normalizeGradeLevelsResponse = (response) => {
  const rows = Array.isArray(response)
    ? response
    : Array.isArray(response?.gradeLevels)
      ? response.gradeLevels
      : Array.isArray(response?.data)
        ? response.data
        : [];

  return rows
    .map((row) => ({
      id: row?.id ?? row?.name ?? row,
      name: String(row?.name ?? row ?? '').trim(),
    }))
    .filter((row) => row.name)
    .sort((a, b) => a.name.localeCompare(b.name));
};

export const parseGradeLevelNames = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }
  return String(value || '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

export const serializeGradeLevelNames = (values) =>
  parseGradeLevelNames(values).join(', ');
